export const COMPONENT_NAME = 'TermsAndCondition';
